import { useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../CredentialApp/hooks/storeHooks";
import { selectCompanyListByRef } from "../reducers/companyListsSlice";
import UserContext from "../../../contexts/UserContext";
import { ICompanyList } from "../types/common";

export const useIsCompanyListOwner = (companyList?: ICompanyList) => {
  const { companyListId } = useParams();
  const userModel = useContext(UserContext);

  const companyListFromRoute = useAppSelector((state) =>
    selectCompanyListByRef(state, companyListId)
  );

  const targetCompanyList = companyList || companyListFromRoute;

  const isOwner = useMemo(() => {
    return userModel?.getUser().uid === targetCompanyList?.uid;
  }, [userModel, targetCompanyList?.uid]);

  return isOwner;
};

export default useIsCompanyListOwner;
